<template>
  <a-card :bordered="false">
    <div class='m-b-20 s_flex_ali'>
      <p>是否直接进入活动页：</p>
      <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="is_join_ac_page" />
      <a-tooltip placement='right'>
        <template #title>控制开启智能营销活动时消费者扫码进入的扫码页面路径，“关闭”表示需先进入箱码扫码页，“开启”表示消费者扫码后直接进入扫码活动模板。
        </template>
        <QuestionCircleOutlined class="m-l-10 s_c376 fz-16" />
      </a-tooltip>
    </div>
    <app-warp :title='form.title ?form.title:"防伪查询"'>
      <template #app-content>
        <div class="pic_content" :style="'background-color:'+form.cover_color">
          <div class="p-10 s_flex_bian_c" :style="'background-color:'+form.goods_bgColor" v-if='form.is_show_goods'>
            <img class="width-70 height-70" style="object-fit:cover" :src="require('@/assets/images/normal.png')" alt="">
            <div class="width75 height-70 s_flex_tb s_flex_wrap">
              <p class="fz-16 s_omit" :style="'color:'+form.goods_titleColor">商品名称</p>
              <div class="s_flex_bian_c width100">
                <p class="fz-14" :style="'color:'+form.goods_priceColor">￥888.00</p>
                <!--占位符-->
                <p class="height-30 width-86 s_flex_center bor-rad-15"
                  :style="'background-color:'+form.goods_bntColor+';color:'+form.goods_bntTextColor">查看详情</p>
              </div>
            </div>
          </div>
          <template v-for="item in form.cover_image_url" :key='item'>
            <img class="width100" style="display: block;height: auto;" :src="info.picdomain+item" alt="">
          </template>
          <p class="height-57"></p>
          <!--占位符-->
        </div>
        <div class="joinContent">
          <img :src="form.enterImg.indexOf('http')==-1?info.picdomain+form.enterImg:form.enterImg" alt="">
          <div :style="'color:'+form.enterTextColor">{{form.enterText}}</div>
        </div>
        <div class="s_po_ab_bl width100 p-8" v-if='form.navData && form.navData.length && form.is_show_nav'>
          <div class="s_flex_jun s_bf width100 p-t-5 p-b-5 m-b-5"
            style="box-shadow: 0px 2px 11px 0px rgba(0, 0, 0, 0.14);border-radius: 5px;">
            <template v-for="items in form.navData" :key="items">
              <div class="width20 text-ac">
                <img class="height-30" style="margin: 0 auto;width:30px;display: block;"
                  :src="items.icon?info.picdomain+items.icon:require('@/assets/images/normal.png')" alt="">
                <span class="fz-12 p-t-5">{{items.name || '名称'}}</span>
              </div>
            </template>
          </div>
        </div>
      </template>
      <template #app-sider>
        <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-tabs v-model:activeKey="activeKey" style="width:95%;margin-left:20px">
            <a-tab-pane :key="1" tab="基础设置">
              <div class="moduleContent">
                <a-form-item label="页面标题">
                  <a-input v-model:value="form.title" placeholder="请输入页面标题" style="width:250px" :maxlength='6'></a-input>
                </a-form-item>
                <a-form-item label="背景图片" help="建议尺寸 750px * 1626px，大小在500Kb以内">
                  <material :groupType='1' :imageList="form.cover_image_url" :max="30" v-on:handlechoose="(data)=>{
                        form.cover_image_url=form.cover_image_url.concat(data)}"
                    v-on:handledel="(data)=>{form.cover_image_url=data}" />
                </a-form-item>
                <a-form-item label="页面背景色" help="页面整体背景色">
                  <a-input v-model:value="form.cover_color" type="color" style="width:150px" />
                  <a-button class="m-l-15" type="primary" @click='form.cover_color = "#f5f5f5"'>恢复默认值</a-button>
                </a-form-item>
              </div>
            </a-tab-pane>
            <a-tab-pane :key="2" tab="底部栏菜单">
              <div class="moduleContent">
                <a-form-item label="是否显示">
                  <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="form.is_show_nav" />
                </a-form-item>
                <a-form-item label="图片导航" v-if='form.is_show_nav'>
                  <div v-for="(item,index) in form.navData" :key='item' class="imagesContent">
                    <CloseOutlined class="images_del" @click="delImagesData(index)" />
                    <a-form-item label="图标" :label-col="{span:4}" :wrapper-col="{span:17}" help="建议尺寸 48px * 48px">
                      <div class="width-104 height-104 s_over">
                        <material :groupType='1' :image="item.icon" :max="1" v-on:handlechoose="(data)=>{item.icon=data}"
                          v-on:handledel="item.icon=''" />
                      </div>
                    </a-form-item>
                    <a-form-item label="名称" :label-col="{span:4}" :wrapper-col="{span:17}" help="限5个字内">
                      <a-input v-model:value="item.name" placeholder="请输入名称" style="width:250px" :maxlength='5'></a-input>
                    </a-form-item>
                    <a-form-item label="链接地址" :label-col="{span:4}" :wrapper-col="{span:17}">
                      <a-input-search v-model:value="item.linkUrl" placeholder="请选择链接地址"
                        @search="navIndex=index;linkVisible=true" readonly>
                        <template #enterButton>
                          <a-button type="primary">选择</a-button>
                        </template>
                      </a-input-search>
                    </a-form-item>
                    <template v-if="item.key=='public'||item.key=='video'">
                      <a-form-item label="背景图" :label-col="{span:4}" :wrapper-col="{span:17}" v-if="item.key=='public'">
                        <div class="width-104 height-104 s_over">
                          <material :groupType='1' :image="item.imgUrl" :max="1"
                            v-on:handlechoose="(data)=>{item.imgUrl=data}" v-on:handledel="item.imgUrl=''" />
                        </div>
                      </a-form-item>
                      <a-form-item label="视频封面" :label-col="{span:4}" :wrapper-col="{span:17}" v-if="item.key=='video'">
                        <div class="width-104 height-104 s_over">
                          <material :groupType='1' :image="item.imgUrl" :max="1"
                            v-on:handlechoose="(data)=>{item.imgUrl=data}" v-on:handledel="item.imgUrl=''" />
                        </div>
                      </a-form-item>
                      <a-form-item label="视频" :label-col="{span:4}" :wrapper-col="{span:17}" v-if="item.key=='video'">
                        <material :groupType='2' :image="item.video_cover" :max="1" v-on:handlechoose="(data)=>{
                            item.video_source=data.file_name;item.video_cover=data.video_image_name}"
                          v-on:handledel="item.video_source='';item.video_cover=''" />
                      </a-form-item>
                    </template>
                  </div>
                  <a-button type="primary" @click="addNav" v-if="form.navData.length < 5">添加一个</a-button>
                </a-form-item>
              </div>
            </a-tab-pane>
            <a-tab-pane :key="3" tab="商品设置">
              <div class="moduleContent">
                <a-form-item label="是否显示关联商品" :label-col="{ span: 4 }">
                  <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="form.is_show_goods" />
                </a-form-item>
                <a-form-item label="背景颜色" :label-col="{ span: 4 }">
                  <a-input v-model:value="form.goods_bgColor" type="color" style="width:150px" />
                </a-form-item>
                <a-form-item label="商品标题颜色" :label-col="{ span: 4 }">
                  <a-input v-model:value="form.goods_titleColor" type="color" style="width:150px" />
                </a-form-item>
                <a-form-item label="商品价格颜色" :label-col="{ span: 4 }">
                  <a-input v-model:value="form.goods_priceColor" type="color" style="width:150px" />
                </a-form-item>
                <a-form-item label="按钮颜色" :label-col="{ span: 4 }">
                  <a-input v-model:value="form.goods_bntColor" type="color" style="width:150px" />
                </a-form-item>
                <a-form-item label="按钮文字颜色" :label-col="{ span: 4 }">
                  <a-input v-model:value="form.goods_bntTextColor" type="color" style="width:150px" />
                </a-form-item>
              </div>
            </a-tab-pane>
            <a-tab-pane :key="4" tab="扫码活动入口配置">
              <div class="moduleContent">
                <a-form-item label="文字" help="文字不输入则不显示，最多输入6个字">
                  <a-input v-model:value="form.enterText" placeholder="请输入入口文字" style="width:250px" :maxlength='6'>
                  </a-input>
                </a-form-item>
                <a-form-item label="图标">
                  <a-radio-group v-model:value="form.enterImgType">
                    <a-radio :value="0">默认图标</a-radio>
                    <a-radio :value="1">自定义图标</a-radio>
                  </a-radio-group>
                  <div class="s_flex_ali m-t-10" v-if="form.enterImgType==0">
                    <div class="width-104 height-104 m-r-10 jionImgBox s_flex_center" v-for="item in joinImg" :key="item"
                      @click="form.enterImg=item">
                      <img class="width-86" :src="info.picdomain+item" alt="">
                      <CheckSquareFilled v-if="form.enterImg==item" class="jionIcon" />
                    </div>
                  </div>
                  <div class="s_flex_ali m-t-10" v-else>
                    <div class="width-104 height-104 s_over">
                      <material :groupType='1' :image="form.enterImg" :max="1"
                        v-on:handlechoose="(data)=>{form.enterImg=data}" v-on:handledel="form.enterImg=''" />
                    </div>
                    <p class="p-l-10 s_c999">推荐宽度200px，高度自定义</p>
                  </div>
                </a-form-item>
                <a-form-item label="文字颜色" help="当存在营销活动时，该抽奖入口才会显示">
                  <a-input v-model:value="form.enterTextColor" type="color" style="width:150px" />
                </a-form-item>
              </div>
            </a-tab-pane>
          </a-tabs>

          <a-button type="primary" v-has:logisticsCodeConfigSubmit="onSubmit" class='m-l-20 m-t-30'>保存</a-button>
        </a-form>
      </template>
    </app-warp>
  </a-card>
  <!-- 链接选择 -->
  <a-modal :keyboard="false" title="链接" centered v-model:visible="linkVisible" @ok="handleOk" :width="1200"
    :footer='null'>
    <untilSelect v-on:success="selecLink" />
  </a-modal>
</template>
<script>
  import { CloseOutlined, QuestionCircleOutlined, CheckSquareFilled } from "@ant-design/icons-vue";
  import { getLogisticsPageDetail, setLogisticsPageDetail } from "@/api/qrcodeActivitys";
  import { onMounted, ref, reactive, toRefs } from "@vue/runtime-core";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import store from '@/store'
  import untilSelect from "./untilSelect";
  let defForm = {
    title: '品牌宣传',
    cover_image_url: ['/web_base_assets/scan/logisticsBg.png'],
    cover_color: '#040e35',
    is_show_nav: 1,
    navData: [{ name: '关注公众号', icon: '/web_base_assets/scan/logisticsPulice.png', linkUrl: 'public', key: 'public', imgUrl: '/web_base_assets/scan/logisticsCodeBg.png' }, { name: '会员中心', icon: '/web_base_assets/scan/logisticsMy.png', linkUrl: 'center', key: 'center' }],
    is_show_goods: 1,
    goods_bgColor: '#ffffff',
    goods_titleColor: '#333333',
    goods_bntColor: '#4FA1FC',
    goods_bntTextColor: '#ffffff',
    goods_priceColor: "#F85724",
    enterText: "前往抽奖",
    enterTextColor: '#F85724',
    enterImgType: 0,
    enterImg: "/web_base_assets/scan/join3.png"
  };
  export default {
    components: { CloseOutlined, untilSelect, QuestionCircleOutlined, CheckSquareFilled },
    setup() {
      const form = ref({ ...defForm });
      const state = reactive({
        joinImg: ['/web_base_assets/scan/join1.png', '/web_base_assets/scan/join2.png', '/web_base_assets/scan/join3.png'],
        is_join_ac_page: 0,
        activeKey: 1,
        linkVisible: false,
        navIndex: 0,
        labelCol: { span: 3 },
        wrapperCol: { span: 18 },
      })
      const addNav = () => {
        form.value.navData.push({ name: '', icon: '', linkUrl: '', key: '' })
      }
      // 删除轮播图片数据
      const delImagesData = (index) => {
        if (form.value.navData.length == 1) {
          message.error("至少要存在一个元素");
        } else {
          form.value.navData.splice(index, 1);
        }
      };
      // 地址选择完成
      const selecLink = (data) => {
        form.value.navData[state.navIndex].linkUrl = data.link;
        form.value.navData[state.navIndex].key = data.key;
        form.value.navData[state.navIndex].icon = data.icon;
        form.value.navData[state.navIndex].name = data.name;
        state.linkVisible = false;
      };
      const initData = async () => {
        let result = await getLogisticsPageDetail().then((res) => res.data).catch((error) => error);
        if (iscode(result, true, false)) {
          form.value = Object.assign(form.value, JSON.parse(result.data.template_content));
          state.is_join_ac_page = result.data.is_join_ac_page;
        }
      };
      const onSubmit = async () => {
        form.value.is_show_nav = form.value.is_show_nav ? 1 : 0
        let result = await setLogisticsPageDetail({ is_join_ac_page: state.is_join_ac_page ? 1 : 0, template_content: JSON.stringify({ ...form.value }) }).then((res) => res.data).catch((error) => error);
        if (iscode(result, true)) {
          initData();
        }
      };
      onMounted(() => {
        initData();
      });
      return {
        form,
        ...toRefs(state),
        onSubmit,
        info: store.state.user.info,
        addNav,
        selecLink,
        delImagesData
      };
    },
  };
</script>

<style lang="less" scoped>
  .moduleContent {
    height: auto;
    background: #fdfdfd;
    border: 1px solid #ddd;
    padding: 20px 10px 40px 10px;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    user-select: none;
  }

  .pic_content {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    overflow-y: scroll;
  }

  .imagesContent {
    padding: 20px;
    background: #f7fafc;
    position: relative;
    border-radius: 3px;
    cursor: move;
    min-height: 240px;
    margin-bottom: 20px;

    .images_del {
      position: absolute;
      right: 20px;
      top: 20px;
      cursor: pointer;
    }
  }

  .jionImgBox {
    position: relative;
    padding: 8px;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    box-sizing: border-box;

    .jionIcon {
      position: absolute;
      bottom: 0;
      right: 0;
      font-size: 20px;
      color: #05486A;
    }
  }

  .joinContent {
    width: 80px;
    position: absolute;
    right: 10px;
    top: 30%;
    text-align: center;

    img {
      width: 100%;
    }
  }
</style>